import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";

const DriverDetailsBanner: React.FC = () => {
  const { t } = useTranslation("webReceipt");
  return (
    <div className="rounded-lg p-4 flex items-center gap-3 bg-brand-blue-light mb-2">
      <InfoIcon color="info" sx={{ fontSize: 24 }} />
      <div className="flex-1">
        <span className="text-base font-medium text-mineshaft-900 leading-tight">
          {t("tripScheduled_driverLocationBanner")}
        </span>
      </div>
    </div>
  );
};

export default DriverDetailsBanner;
